import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { FormControlContainer } from '../../../components/formControlContainer';
import { ALL_BUY_IN_AMOUNTS } from '../../../constants/buyInConstants';
import { setCreateGameIsAggroBettingFilterEnabled } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ALL_CURRENCIES } from '../../../types/sharedTypes';
import { getCurrencyAmountString } from '../../../utils/currencyUtils';
export const AggroBettingFilterControl = () => {
    const dispatch = useAppDispatch();
    const buyInIndex = useAppSelector((state) => state.createGame.buyInIndex);
    const currencyIndex = useAppSelector((state) => state.createGame.currencyIndex);
    const isAggroBettingFilterEnabled = useAppSelector((state) => state.createGame.isAggroBettingFilterEnabled);
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const variantId = useAppSelector((state) => state.createGame.variantId);
    const onChange = useCallback((event) => {
        dispatch(setCreateGameIsAggroBettingFilterEnabled(event.target.checked));
    }, [dispatch]);
    if (roomType !== 'regular') {
        // control not relevant
        return null;
    }
    if (variantId !== 0) {
        // variant ID is 'texas' and is the only relevant variant for aggro betting filter
        // TODO: Determine if mixed games allows this?
        return null;
    }
    return (_jsxs(FormControlContainer, { isFlex: true, children: [_jsx(FormControl, { component: 'fieldset', children: buyInIndex === 0 ? (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: true, disabled: true }), label: 'Aggro Betting Filter' })) : (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isAggroBettingFilterEnabled, onChange: onChange }), label: 'Aggro Betting Filter' })) }), buyInIndex === 0 && (_jsxs(Typography, { variant: 'subtitle2', component: 'div', color: 'secondary', children: ["Automatically enabled when Buy-in is", ' ', getCurrencyAmountString(ALL_BUY_IN_AMOUNTS[buyInIndex], ALL_CURRENCIES[currencyIndex]), ". Increase Buy-in to control this setting."] })), _jsx(Typography, { variant: 'subtitle2', component: 'div', children: "When on, players that repeatedly make huge overbets will be warned, and then banned from the room if it continues. This limits super-aggressive play and encourages more strategy." })] }));
};
